import { render, staticRenderFns } from "./SettingsMenu.vue?vue&type=template&id=7edd899f&scoped=true&"
import script from "./SettingsMenu.vue?vue&type=script&lang=js&"
export * from "./SettingsMenu.vue?vue&type=script&lang=js&"
import style0 from "./SettingsMenu.vue?vue&type=style&index=0&id=7edd899f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edd899f",
  null
  
)

export default component.exports